export default "/images/149723e96affa60ba7581ec398e069ef.avif";